module.exports = __webpack_public_path__ + "media/images/chat_bg_light-8bcb830ece7cf52dd94351c94364c7d4.jpg";